// extracted by mini-css-extract-plugin
export default {"root":"DRqD4GGc5H35a2JjS4Hv"};